export default function initIconInfo() {
    const tooltipWrappers = document.querySelectorAll('.tooltip__wrapper');

    tooltipWrappers.forEach(wrapper => {
        const tooltip = wrapper.querySelector('.tooltip__text');

        wrapper.addEventListener('mouseenter', (event) => {
            showTooltip(tooltip);
            positionTooltip(wrapper, tooltip);
        });

        wrapper.addEventListener('mousemove', (event) => {
            positionTooltip(wrapper, tooltip);
        });

        wrapper.addEventListener('mouseleave', () => {
            hideTooltip(tooltip);
        });

        window.addEventListener('resize', () => {
            if (tooltip.classList.contains('opacity-100')) {
                positionTooltip(wrapper, tooltip);
            }
        });
    });
}

function showTooltip(tooltip) {
    tooltip.classList.remove('opacity-0', 'scale-95');
    tooltip.classList.add('opacity-100', 'scale-100');
}

function hideTooltip(tooltip) {
    tooltip.classList.remove('opacity-100', 'scale-100');
    tooltip.classList.add('opacity-0', 'scale-95');
}

function positionTooltip(wrapper, tooltip) {
    const iconRect = wrapper.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Default positions
    let leftPosition = iconRect.left + (iconRect.width / 2) - (tooltipRect.width / 2);
    let topPosition = iconRect.top - tooltipRect.height - 5; // 5px offset above the icon

    // Adjust if tooltip goes out of the viewport horizontally
    if (leftPosition < 0) {
        leftPosition = 0;
    } else if (leftPosition + tooltipRect.width > viewportWidth) {
        leftPosition = viewportWidth - tooltipRect.width;
    }

    // Adjust if tooltip goes out of the viewport vertically
    if (topPosition < 0) {
        topPosition = iconRect.bottom + 5; // Position below the icon if it goes out of the top
    }

    tooltip.style.left = `${leftPosition - iconRect.left}px`;
    tooltip.style.top = `${topPosition - iconRect.top}px`;
}